const EL_MATCHES_METHOD = ['matches', 'msMatchesSelector', 'webkitMatchesSelector']
  .find(methodName => window.Element.prototype[methodName])

/* istanbul ignore next */
function elMatches (element, selector) {
  return element[EL_MATCHES_METHOD](selector)
}

function elClosest (element, selector) {
  let result = null

  // since we run our tests in Chrome, the `else` will never run
  /* istanbul ignore else */
  if (window.Element.prototype.closest) {
    result = element.closest(selector)
  } else {
    let ancestor = element

    if (document.documentElement.contains(element)) {
      do {
        if (elMatches(ancestor, selector)) {
          result = ancestor
          ancestor = null
        } else {
          ancestor = ancestor.parentElement
        }
      } while (ancestor !== null)
    }
  }

  return result
}

/**
 * A vanilla implementation of the `jQuery.on` method
 *
 * @param {Element} element
 * @param {String} eventName
 * @param {String} [selector]
 * @param {Function} handler
 *
 * @example
 * import { handleEvent } from '@cwp/utils'
 *
 * const myLink = document.getElementById('my-link')
 *
 * // handle click events on myLink element
 * handleEvent(myLink, 'click', event => {
 *   const link = event.target
 * })
 *
 * // handle click events on all `.link`s within `document`
 * handleEvent(document, 'click', '.link', event => {
 *   const link = event.target
 * })
 */
export default function handleEvent (element, eventName, selector, handler) {
  // no selector provided
  if (!handler) {
    handler = selector
    selector = null
  }

  if (selector) {
    element.addEventListener(eventName, event => {
      const targetElement = event.target
      const selectorMatch = elClosest(targetElement, selector)

      if (selectorMatch && element.contains(selectorMatch)) {
        handler.call(selectorMatch, event)
      }
    })
  } else {
    element.addEventListener(eventName, handler)
  }
}
